// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"dd0700b6","939":"d720c6ef"}[chunkId] + ".chunk.js";
};